export default __webpack_public_path__ + "static/media/tomatoNt1.8543c6fc.png";